import ClassicExtension from "./ClassicExtension";

/**
 * Stops propagation of some js event
 * more events can be defined as "focus blur"
 */
export default class StopEventPropagationExtension extends ClassicExtension {

    protected init($root: JQuery): void {
        $root.find('[data-stop-event-propagation]').each( (i,el) => {
            const $el = $(el);
            const event = $el.data('stop-event-propagation');

            $el.on(event, e => {
                e.stopPropagation();
                e.preventDefault();
            } );
        });
    }
}
